import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  Alert
} from "react-bootstrap";

import { AlertInfo } from "../../components/Alert/AlertInfo.jsx";
import { Card } from "../../components/Card/Card.jsx";
import { FormInputs } from "../../components/FormInputs/FormInputs.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";

import { NavLink } from "react-router-dom";

import { Query, Mutation } from "react-apollo";
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import gql from "graphql-tag";
import { HttpLink } from 'apollo-link-http';

import NotificationSystem from "react-notification-system";
import { style } from "../../variables/Variables.jsx";

import Select from 'react-select';
import DateTimePicker from 'react-datetime-picker';


const restLink_vm = new HttpLink({ 
  uri: "/api/v1/cloud/",
  credentials: 'include'
});
const cloud_client = new ApolloClient({
  link: restLink_vm,
  cache: new InMemoryCache(),
});

const ADD_TODO = gql`
  mutation createOrUpdateVm($id: Int!, $title: String!, $description: String!, $memory_size_mib: Int!, $num_vcpus_per_socket: Int!, $num_sockets: Int!, $num_threads_per_core: Int!){
    createOrUpdateVm(id:$id,input:{title: $title, description:$description, memory_size_mib:$memory_size_mib, num_vcpus_per_socket:$num_vcpus_per_socket, num_sockets: $num_sockets, num_threads_per_core: $num_threads_per_core}) {
      id
    }
  }
`;

const GET_VM = gql`
  query getVm($vm_id: Int!){
    vm(id:$vm_id){
      id
      title
      description
      state
      memory_size_mib
      num_vcpus_per_socket
      num_sockets
      num_threads_per_core
    }
  }
`;

class VmItem extends Component {

  vm_id;
  vm_edit;

  constructor() {
    super();
    this.state = {
      alertInfo: "",
      datePublish: new Date(),
      dateUnpublish: null
    };


    this.start_publish_date = true;
    this.start_unpublish_date = true;
    this.start_active = true;
    this.start_blockcontent = true;
    
    
  }

  onChange_datePublish = datePublish => this.setState({ datePublish })
  onChange_dateUnpublish = dateUnpublish => this.setState({ dateUnpublish })

  handleCheckboxChange = (e) => {
    this.setState(state => ({
      ...state,
      checkboxValue_active: !this.state.checkboxValue_active
    }));

  }

  


  handleSubmit = (event) => {
    event.preventDefault();
    
    this.setState({
      alertInfo: "Salvo com sucesso!"
    });

    setTimeout(() => {
      this.setState({
        alertInfo: ""
      })
    },3000);
  }

  
  render() {

    
    if(this.props.match.params.id) {
      this.vm_id = this.props.match.params.id;
    } else {
      this.vm_id = 0;
    }

    return (


      <Query
      client={cloud_client}
      query={GET_VM}
      variables={{vm_id:this.vm_id}}
      >
      {({ loading, error, data }) => {
        if (loading) return <div>Carregando...</div>;
        if (error) return <div>Erro :(</div>;
          
          this.vm_edit = data.vm;

        return (

      <Mutation mutation={ADD_TODO} client={cloud_client}>
      {(createOrUpdateVm, { data }) => {
      
        console.log("-------------- MUTATION -----------------");
        console.log(data);

      return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
            
              <NavLink
                  to="/Vm"
                  className="btn btn-info btn-fill"
                  activeClassName=""
                >
                VOLTAR
              </NavLink>
              <NotificationSystem ref="notificationSystem" style={style} />

            
              <Card
                title={"Instância: "+this.vm_edit.title}
                content={
                  <form 
                  onSubmit={e => {
                    this.handleSubmit(e);
                    e.preventDefault();
                    createOrUpdateVm({variables: { 
                      id: this.vm_id, 
                      title: this.vm_edit.title,
                      description: "",
                      memory_size_mib: (e.target.elements.memory_size_mib.value * 1024),
                      num_vcpus_per_socket: e.target.elements.num_vcpus_per_socket.value,
                      num_sockets: 1,
                      num_threads_per_core: 1
                    } });
                  }}
                  >

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        name: "memory_size_mib",
                        label: "Memória RAM em GB",
                        type: "number",
                        bsClass: "form-control",
                        placeholder: "Memória RAM em GB",
                        defaultValue: (this.vm_edit ? this.vm_edit.memory_size_mib / 1024 : "")
                      }
                    ]}
                  />

                  <FormInputs
                    ncols={["col-md-12"]}
                    proprieties={[
                      {
                        name: "num_vcpus_per_socket",
                        label: "Número de VCPUs",
                        type: "number",
                        bsClass: "form-control",
                        placeholder: "Número de VCPUs por socket",
                        defaultValue: (this.vm_edit ? this.vm_edit.num_vcpus_per_socket : "")
                      }
                    ]}
                  />

                  <Row>
                    <Col md={10}>
                      <AlertInfo ref="alertSave" alertInfo={this.state.alertInfo} />
                    </Col>
                    <Col md={2}>
                      <Button bsStyle="info" pullRight fill type="submit">
                        Salvar
                      </Button>
                    </Col>
                  </Row>
                    <div className="clearfix" />
                  </form>
                }
              />

            </Col>
            
          </Row>
        </Grid>
      </div>
      )}}
      </Mutation>

      );
      }}
      </Query>
    );
  }
}

export default VmItem;
